import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const Index = () => {
  return <App />;
};

const container = document.getElementById('wrapper');
const root = createRoot(container!);
root.render(<Index />);
